import { lazyModuleMethod } from '@/helpers/lazyModuleMethod'

export const podcastDistribution = {
  changePodcastDistribution: lazyModuleMethod(
    () => import('./changePodcastDistribution'),
    'default'
  ),
}
